import React from 'react';
import {
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import FolderIcon from '@mui/icons-material/Folder';
import { Calendar } from '../../types/calendar';

interface CalendarsTabProps {
  calendars: Calendar[];
}

export const CalendarsTab: React.FC<CalendarsTabProps> = ({ calendars }) => {
  return (
    <Paper elevation={2} sx={{ p: 2 }}>
      <List>
        {calendars.map(cal => (
          <ListItem key={cal.id}>
            <ListItemIcon>
              <FolderIcon />
            </ListItemIcon>
            <ListItemText primary={cal.name} secondary={`ID: ${cal.id}${cal.isDefault ? ', За замовчуванням' : ''}`} />
          </ListItem>
        ))}
      </List>
    </Paper>
  );
};
